<template>
  <v-expansion-panels v-model="panel" class="mt-2" multiple focusable>
    <template v-for="content in panelData">
      <v-expansion-panel class="my-2" :key="content.text">
        <v-expansion-panel-header
          ><h6 class="mb-0">{{ content.header }}</h6></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <div class="row" v-if="content.isShownCommonInput === true">
            <CommonInput
              v-model.number="form['minimumSpending' + content.text]"
              :error="error['errorMinimumSpending' + content.text]"
              :is-submit="isSubmit"
              label="Min spending in past 12 months"
              :set-padding="true"
              :identifier="'minimumSpending_' + content.text"
            />
          </div>
          <LineMessageTemplate
            v-show="form.isSentViaLine"
            :trigger-type="form.triggerType"
            :message-template="form['messageTemplatesFor' + content.text]"
            :error-message-templates="
              error['errorMessageTemplatesLineFor' + content.text]
            "
            :error="error"
            :is-submit="isSubmit"
            :data-id="
              'message-tooltip-' +
              convertFirstLetterToLowerCase(content.text) +
              '-line'
            "
            :identifier="
              convertFirstLetterToLowerCase(content.text) + 'Template'
            "
          />
          <SmsMessageTemplate
            v-show="form.isSentViaSms"
            :trigger-type="form.triggerType"
            :message-template="form['messageTemplatesFor' + content.text]"
            :error-message-templates="
              error['errorMessageTemplatesSmsFor' + content.text]
            "
            :is-submit="isSubmit"
            :data-id="
              'message-tooltip-' +
              convertFirstLetterToLowerCase(content.text) +
              '-sms'
            "
            :identifier="
              convertFirstLetterToLowerCase(content.text) + 'Template'
            "
          />
          <PushNotificationTemplate
            v-show="form.isSentViaPushNoti"
            :trigger-type="form.triggerType"
            :message-template="form['messageTemplatesFor' + content.text]"
            :error-message-templates="
              error['errorMessageTemplatesPushNotiFor' + content.text]
            "
            :error="error"
            :is-submit="isSubmit"
            :data-id="
              'message-tooltip-' +
              convertFirstLetterToLowerCase(content.text) +
              '-push-noti'
            "
            :identifier="
              convertFirstLetterToLowerCase(content.text) + 'Template'
            "
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
import CommonInput from "@/views/CrmTrigger/CommonInput.vue";
import SmsMessageTemplate from "components/MessageTemplate/SmsMessageTemplate.vue";
import LineMessageTemplate from "components/MessageTemplate/LineMessageTemplate.vue";
import PushNotificationTemplate from "components/MessageTemplate/PushNotificationTemplate.vue";

export default {
  components: {
    PushNotificationTemplate,
    LineMessageTemplate,
    SmsMessageTemplate,
    CommonInput,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      panel: [0, 1, 2, 3, 4],
      panelData: [
        {
          header: "SFS LX HV",
          text: "SfsLxHv",
          isShownCommonInput: true,
        },
        {
          header: "SFS LX LV",
          text: "SfsLxLv",
          isShownCommonInput: true,
        },
        {
          header: "Non-SFS LX HV",
          text: "NonSfsLxHv",
          isShownCommonInput: true,
        },
        {
          header: "Non-SFS LX LV",
          text: "NonSfsLxLv",
          isShownCommonInput: true,
        },
        {
          header: "Any purchase",
          text: "AnyPurchase",
          isShownCommonInput: false,
        },
      ],
    };
  },
  methods: {
    convertFirstLetterToLowerCase(text) {
      return text.charAt(0).toLowerCase() + text.slice(1);
    },
  },
};
</script>
<style lang="scss" scoped>
.label-title {
  font-weight: 600;
}
</style>
